<template>
  <div class="header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="float-left"></div>
          <div class="float-right">
            <div class="dropdown dib">
              <div class="header-icon" data-toggle="dropdown">
                <span class="user-avatar">{{ user.name }}</span>
                <div class="drop-down dropdown-profile dropdown-menu dropdown-menu-right">
                  <div class="dropdown-content-body">
                    <ul>
                      <li>
                        <a href="#" id="logut" @click.prevent="logoutHandler">
                          <i class="ti-power-off"></i>
                          <span>Logout</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.loginState.account
        ? this.$store.state.loginState
        : {};
    }
  },
  methods: {
    logoutHandler() {
      $.ajax({
        url: "./php/main.php",
        type: "post",
        data: { function: "logout" }
      }).done(() => {
        this.$router.push({ path: "/login" });
      });
    },
    sideBarHandler() {}
  }
};
</script>